// extracted by mini-css-extract-plugin
export const row = "index-module--row--y4Yk7";
export const link = "index-module--link--3uD_F";
export const left = "index-module--left--2pFCl";
export const timeline = "index-module--timeline--3fFKn";
export const right = "index-module--right--31ZQq";
export const coverImgWrapper = "index-module--coverImgWrapper--3QRBL";
export const coverImg = "index-module--coverImg--2K5Bj";